import { isDomContentLoaded } from '../../../modules/get_perfomance'
import { getApiUrlString, setUrlMap } from '../../../modules/get_apiUrlString'
import { getCode } from '../../../modules/get_code'
import seasonText from '../../../json/seasonText.json'

import buildSelect from "./buildSelect";

export default () => {

  const e = {};
  const init = () => {
    setUrlMap(window.pist6);
    const worker = new Worker('/assets/js/data/worker/api_thread.js');
    worker.postMessage({
      url: getApiUrlString('year'),
      cb: (cb).toString()
    })
    worker.addEventListener('message', evt => {
      if (isDomContentLoaded()) {
        buildExplore();
        buildYearSelect(evt.data);
        buildSeasonSelect();
        buildRoundSelect();
      } else {
        window.addEventListener('DOMContentLoaded', () => {
          buildExplore();
          buildYearSelect(evt.data);
          buildSeasonSelect();
          buildRoundSelect();
        })
      }
    })

    createApiWorker();
  }

  // worker側で実行される処理
  const cb = (data) => {
    console.log(data)
    const seasonList = data.api.promoter_year_list
      .filter(yearObj => yearObj.promoter_year <= data.api.current_promoter_year)
      .map(yearObj => {
        return {
          value: yearObj.promoter_year,
          text: `${yearObj.promoter_year} - ${yearObj.promoter_year + 1}`
        }
      });
      console.log(seasonList)
    postMessage(seasonList);
  }

  const buildExplore = () => {
    e.root = document.getElementById('explore');
    e.searchBtn = e.root.querySelector('.le-explore-instruction__search .c-btn-rcorner');
  }
  const buildYearSelect = (yearData) => {
    // カスタムセレクトのインスタンス作成
    const yearSelect = buildSelect('year');
    yearSelect.build(yearData);

    // worker側で実行される処理
    const cb = (data) => {
      console.log('buildYearSelect', data);
      const currentDateTime = Date.now();
      const seasonList = [];
      data.api.round_list.map(roundObj => {
          return {
            date: roundObj.first_day,
            datetime: (new Date(roundObj.first_day)).getTime(),
            season: roundObj.season
          }
        })
        .sort((a, b) => a.datetime - b.datetime)
        .filter(roundObj => currentDateTime > roundObj.datetime)
        .forEach(roundObj => {
          if (!seasonList.includes(roundObj.season)) {
            seasonList.push(roundObj.season);
          }
        });
      console.log(seasonList);

      const postData = seasonList.map(seasonTxt => {
        return {
          value: seasonTxt.toLowerCase(),
          text: data.post.jsonMap[seasonTxt.toLowerCase()].ja
        }
      })
      console.log(postData);

      postMessage(postData);
    }

    // 年度セレクトをクリックした時点で、シーズン・ラウンドセレクトの中身は破棄
    yearSelect.onClick(() => {
      e.season.destroy();
      e.round.destroy();
    })
    // 年度セレクトの内容が変更されたら
    //  1, シーズン・ラウンドセレクトの中身は破棄
    //  2, 検索ボタンはdisabled
    //  3, 選択されたデータを基にラウンドのデータを取得し、シーズンセレクトに流し込む
    yearSelect.onChange(() => {
      e.season.destroy();
      e.round.destroy();
      setStartStatus();

      const queryString = `?promoter_year=${yearSelect.getValue()}`;
      getApiData('round', queryString, cb, seasonText)
        .then(data => {
          console.log('seasonSelectData', data);
          e.season.build(data);
        })

    });
    e.year = yearSelect;
  }
  const buildSeasonSelect = () => {
    // カスタムセレクトのインスタンス作成
    const seasonSelect = buildSelect('season');

    // worker側で実行される処理
    const cb = (data) => {
      console.log('buildSeasonSelect', data);
      const currentDateTime = Date.now();
      const roundCodeList = data.api.round_list.map(roundObj => {
          return {
            date: roundObj.first_day,
            datetime: (new Date(roundObj.first_day)).getTime(),
            code: roundObj.code
          }
        })
        .sort((a, b) => a.datetime - b.datetime)
        .filter(roundObj => currentDateTime > roundObj.datetime)
        .map(roundObj => roundObj.code);
      // console.log(roundCodeList);

      postMessage(roundCodeList);
    }
    // シーズンセレクトをクリックした時点で、ラウンドセレクトの中身は破棄
    seasonSelect.onClick(() => {
      e.round.destroy();
    })
    // シーズンセレクトの内容が変更されたら
    //  1, ラウンドセレクトの中身は破棄
    //  2, 検索ボタンはdisabled
    //  3, 選択されたデータを基にラウンドのデータを取得し、ラウンドセレクトに流し込む
    seasonSelect.onChange(() => {
      e.round.destroy();
      setStartStatus();

      const queryString = `?promoter_year=${e.year.getValue()}&season=${seasonSelect.getValue()}`;
      getApiData('round', queryString, cb)
        .then(data => {
          console.log('roundSelectData', data)
          const roundList = data.map(roundCode => {
            return {
              value: roundCode,
              text: getCode('round', roundCode).name
            }
          });

          e.round.build(roundList);
        })

    });
    e.season = seasonSelect;
  }
  const buildRoundSelect = () => {
    // カスタムセレクトのインスタンス作成
    const roundSelect = buildSelect('round');

    // ラウンドセレクトの内容が変更されたら
    //  1, 検索ボタンはactive
    //  2, 開催レース情報の該当年度・シーズン・ラウンドのクエリを作成
    roundSelect.onChange(() => {
      e.searchBtn.classList.remove('_disabled');
      e.searchBtn.href = `${e.searchBtn.dataset.href}${getSearchApiQuery()}`;
    })
    e.round = roundSelect;
  }

  const setStartStatus = () => {
    e.searchBtn.classList.add('_disabled');
  }

  const createApiWorker = () => {
    e.worker = new Worker('/assets/js/data/worker/api_thread.js');
  }
  const getApiData = (target, query, cb, jsonMap) => {
    return new Promise(resolve => {
      const postData = {
        'url': getApiUrlString(target, query),
        'cb': (cb).toString(),
      }
      if (jsonMap) {
        postData.jsonMap = jsonMap;
      }
      e.worker.postMessage(postData);
      e.worker.addEventListener('message', evt => {
        resolve(evt.data)
      })
    })
  }
  const getSearchApiQuery = () => {
    const yearKv = `year=${e.year.getValue()}`;
    const seasonKv = `season=${e.season.getValue()}`;
    const roundKv = `round_code=${e.round.getValue()}`;
    return '?'+[yearKv, seasonKv, roundKv].join('&');
  }

  init();
}
